<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>Inicio &gt; Demo Componentes Q</p>
    </div>

    <!-- Botones -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card p-4">
          <h6 class="mb-3">Botones</h6>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <QBtn variant="confirma" label="Guardar" />
            <QBtn variant="cancela"  label="Borrar" />
            <QBtn variant="tipster"  label="Inicia sesión" />
            <QBtn variant="neutro"   label="Volver" />
            <QBtn variant="verde"    icon="pi pi-plus" />
            <QBtn variant="confirma" label="Cargando..." :loading="true" />
            <QBtn variant="confirma" label="Desactivado" :disabled="true" />
          </div>
        </div>
      </div>
    </div>

    <!-- Badges -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card p-4">
          <h6 class="mb-3">Badges de estado</h6>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <QBadge status="activo" />
            <QBadge status="inactivo" />
            <QBadge status="pendiente" />
            <QBadge status="borrado" />
            <QBadge status="pagado" />
            <QBadge status="devuelto" />
            <QBadge status="cancelado" />
            <QBadge status="bot" />
            <QBadge status="activo" label="Texto custom" />
          </div>
        </div>
      </div>
    </div>

    <!-- Mini-cards KPI -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card p-4">
          <h6 class="mb-3">Mini-cards KPI</h6>
          <div class="row g-3">
            <div class="col-6 col-lg-2">
              <QMiniCard label="Campañas" :value="12" />
            </div>
            <div class="col-6 col-lg-2">
              <QMiniCard label="Entradas" :value="340" />
            </div>
            <div class="col-6 col-lg-2">
              <QMiniCard label="Suscritos" :value="89" />
            </div>
            <div class="col-6 col-lg-2">
              <QMiniCard label="Bajas" :value="14" />
            </div>
            <div class="col-6 col-lg-2">
              <QMiniCard label="Ingresos" :value="1234.5" :money="true" />
            </div>
            <div class="col-6 col-lg-2">
              <QMiniCard label="Conversión" :value="26.4" :percent="true" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Comparativa con los estilos actuales -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card p-4">
          <h6 class="mb-3">Comparativa — Estilos actuales (Bootstrap) vs Q (PrimeVue)</h6>
          <div class="d-flex flex-wrap gap-3 align-items-center mb-3">
            <span class="text-sm opacity-7">Actual:</span>
            <button class="btn btn-confirma px-4"><span class="text-sm">Guardar</span></button>
            <button class="btn btn-cancela px-4"><span class="text-sm">Borrar</span></button>
            <div class="btn btn-tipster px-4"><span class="text-sm">Inicia sesión</span></div>
            <button class="btn btn-neutro px-4">Volver</button>
            <span class="badge bg-gradient-success">Activo</span>
            <span class="badge bg-gradient-danger">Error</span>
            <span class="badge bg-gradient-secondary">Borrado</span>
          </div>
          <div class="d-flex flex-wrap gap-3 align-items-center">
            <span class="text-sm opacity-7">PrimeVue:</span>
            <QBtn variant="confirma" label="Guardar" />
            <QBtn variant="cancela"  label="Borrar" />
            <QBtn variant="tipster"  label="Inicia sesión" />
            <QBtn variant="neutro"   label="Volver" />
            <QBadge status="activo" />
            <QBadge status="error" />
            <QBadge status="borrado" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default { name: "Blank" };
</script>
